import CaptainActionLogsAPI from 'dashboard/api/captain/actionLogs';

const state = {
  records: [],
  meta: { total: 0, page: 1, per_page: 25, pending_count: 0 },
  uiFlags: {
    fetching: false,
    approving: false,
  },
};

const getters = {
  getRecords: s => s.records,
  getMeta: s => s.meta,
  getUIFlags: s => s.uiFlags,
  getPendingCount: s => s.meta.pending_count,
};

const mutations = {
  SET_RECORDS(s, records) {
    s.records = records;
  },
  SET_META(s, meta) {
    s.meta = meta;
  },
  UPDATE_RECORD(s, updated) {
    const idx = s.records.findIndex(r => r.id === updated.id);
    if (idx !== -1) {
      s.records[idx] = updated;
      s.records = [...s.records];
    }
  },
  SET_UI_FLAG(s, flags) {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
};

const actions = {
  fetch: async ({ commit }, params = {}) => {
    commit('SET_UI_FLAG', { fetching: true });
    try {
      const response = await CaptainActionLogsAPI.get(params);
      commit('SET_RECORDS', response.data.action_logs);
      commit('SET_META', response.data.meta);
    } finally {
      commit('SET_UI_FLAG', { fetching: false });
    }
  },

  approve: async ({ commit }, { id, notes }) => {
    commit('SET_UI_FLAG', { approving: true });
    try {
      const response = await CaptainActionLogsAPI.approve(id, { notes });
      commit('UPDATE_RECORD', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { approving: false });
    }
  },

  block: async ({ commit }, { id, notes }) => {
    commit('SET_UI_FLAG', { approving: true });
    try {
      const response = await CaptainActionLogsAPI.block(id, { notes });
      commit('UPDATE_RECORD', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { approving: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
